export const READY = 'app-qa/READY';
const BUSY = 'app-qa/BUSY';
export const ERROR = 'app-qa/ERROR';

export const ready = () => ({type: READY});

export const busy = ({blockUi} = {}) => ({type: BUSY, blockUi});

export const appError = ({err}) => ({type: ERROR, err});

const initalState = {ready: false, error: null, blockUi: false};

export default function reducer(state = initalState, {type, blockUi, err}) {
  switch (type) {
    case READY:
      return Object.assign({}, state, {ready: true, error: null, blockUi: false});
    case BUSY:
      return Object.assign({}, state, {ready: false, error: null, blockUi});
    case ERROR: {
      return Object.assign({}, state, {ready: true, error: err, blockUi: false});
    }
    default:
      return state;
  }
}
